import { dataQuestionCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconQuestionCircleSolid = /*#__PURE__*/createIcon(dataQuestionCircleSolid)
export default IconQuestionCircleSolid
